import React from "react"

export default function Artbreak() {
  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "Muar-Regular";
          src: url("/fonts/Muar-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Muar-Stencil";
          src: url("/fonts/Muar-Stencil.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
      `}</style>
      <div className="container mx-auto px-4 py-12 max-w-5xl">
        <h1 className="text-5xl mb-12 text-center text-purple-800 font-['Muar-Stencil']">
          Artbreak - Sound healing comedy
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          <div className="aspect-w-16 aspect-h-9 h-0 pb-[56.25%] relative">
            <iframe
              src="https://www.youtube.com/embed/EKydMWjs_ZE"
              title="Artbreak Highlights 1"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            ></iframe>
          </div>
          <div className="aspect-w-16 aspect-h-9 h-0 pb-[56.25%] relative">
            <iframe
              src="https://www.youtube.com/embed/Op6RByw5dLk"
              title="Artbreak Highlights 2"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            ></iframe>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12 items-center">
          <div className="space-y-6">
            <div className="bg-purple-50 p-8 rounded-lg shadow-lg">
              <p className="text-lg leading-relaxed text-gray-700 font-['Muar-Regular'] mb-6">
                What comedy and music have in common is a swing between{" "}
                <b>tension</b> and <b>release</b>. By making extra relaxing
                music (sound healing), and extra dark humor (mockery, self
                reflection and reflection of self), Artbreak intends to{" "}
                <b>expand all levels of consciousness</b>. A unique performance
                in which, by creating a center from the enhancing polarities, we
                find out that the greatest irony is there being no irony at all.
                A performative show, to be presented in any stage, retreat or
                event. Book yours here:
              </p>
              <a
                href="https://wa.me/+351965220370?text=Hello Luís, I would like to book an Artbreak session, please."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-purple-700 font-bold py-3 px-8 rounded-full transition duration-300 ease-in-out transform hover:scale-105 hover:bg-purple-100 shadow-md mt-4"
              >
                Book yours
              </a>
            </div>
          </div>
          <div className="relative">
            <img
              src="/images/Artbreak.jpeg"
              alt="Poster de Artbreak"
              className="w-4/5 mx-auto rounded-lg shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-purple-800 to-transparent opacity-30 rounded-lg"></div>
          </div>
        </div>
      </div>
    </>
  )
}
